import * as React from 'react';
import { createContext, useContext } from 'react';

import type { Response } from 'bundles/compound-assessments/components/local-state/changed-response/types';
import type { QuizQuestionPrompt } from 'bundles/compound-assessments/types/FormParts';

export type QuestionContextType = {
  isReadOnly: boolean;
  isDisabled: boolean;
  showValidation: boolean;
  isGraderView: boolean;
  responseId: string;
  localScopeId: string;
  prompt: QuizQuestionPrompt;
  response: Response;
};

export const QuestionContext = createContext<QuestionContextType | undefined>(undefined);

export const useQuestionContext = () => useContext(QuestionContext);

export const QuestionContextProvider: React.FC<QuestionContextType> = ({ children, ...contextValue }) => {
  return <QuestionContext.Provider value={contextValue}>{children}</QuestionContext.Provider>;
};
